import React from 'react'
import Name from './Name/Name'
import Brand from './BrandManufacturer/BrandManufacturer'
import UPC from './UPC/UPC'
import SKU from './SKU/SKU'
import styles from './styles.module.css'
import ManufacturerNumber from './ManufacturerNumber/ManufacturerNumber'

function About ({
  localName,
  setLocalName,
  isQueryLoading,
  localGTIN,
  setLocalGTIN,
  localSKUS,
  setLocalSKUS,
  localBrandManufacturer,
  setLocalBrandManufacturer,
  localManufacturerNumber,
  setLocalManufacturerNumber
}) {
  return (
    <div className={styles.aboutContainer}>
      <h1 className={styles.aboutTitle}>About</h1>
      <div className={styles.aboutFields}>
        <Name
          localName={localName}
          setLocalName={setLocalName}
          isQueryLoading={isQueryLoading}
        />
        <Brand
          localBrandManufacturer={localBrandManufacturer}
          setLocalBrandManufacturer={setLocalBrandManufacturer}
          isQueryLoading={isQueryLoading}
        />
        <UPC
          localGTIN={localGTIN}
          setLocalGTIN={setLocalGTIN}
          isQueryLoading={isQueryLoading}
        />
        <SKU
          localSKUS={localSKUS}
          setLocalSKUS={setLocalSKUS}
          isQueryLoading={isQueryLoading}
        />
      </div>
      <div className={styles.containerManufacturerNumber}>
        <ManufacturerNumber
          localManufacturerNumber={localManufacturerNumber}
          setLocalManufacturerNumber={setLocalManufacturerNumber}
          isQueryLoading={isQueryLoading}
        />
      </div>
    </div>
  )
}

export default About
